import { currenciesZodSchema } from '@mint-lib/currencies-helpers';
import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const LevelTypeEnum = z.enum([
  'activity',
  'channel',
  'platform',
  'custom',
  'media_row',
]);

export const MediaDataSchema = z.object({
  id: z.string(),
  mediaItemId: z.coerce.string(),
  name: z.string(),
  hasChildren: z.boolean(),
  levelType: LevelTypeEnum.nullable(),
  currencyCode: currenciesZodSchema,
  label: z.string(),
  updatedAt: z.string().optional().default(''),
  attributes: z.record(
    z.string(),
    z.object({
      value: z
        .union([
          z.string(),
          z.number(),
          z.boolean(),
          z.array(z.string()),
          z.object({
            value: z.coerce.number().nullable(),
            refUrn: z.string(),
          }),
        ])
        .nullable(),
      isReadOnly: z.boolean(),
    }),
  ),
  canBeDeleted: z.boolean(),
  mediaRowProps: z
    .object({
      isConfigured: z.boolean(),
      isCampaignSettingsAvailable: z.boolean(),
      platformName: z.string(),
    })
    .nullable(),
});

export const GetMediaDataResponseSchema = createResponseSchema(MediaDataSchema);

export const GetMediaDataQuerySchema = z.object({
  offset: z.number(),
  limit: z.number(),
  getChildren: z.boolean().optional(),
  flightVersionId: z.string().optional(),
});
